{
  "accountBlocked": "账户已被封禁",
  "accountInactive": "账户未激活",
  "alreadyHaveAccount": "已有账户？",
  "backToLogin": "返回登录",
  "backupCode": "备用验证码",
  "confirmPassword": "确认密码",
  "continue": "继续",
  "createAccount": "创建账户",
  "creatingAccount": "创建账户中...",
  "dontHaveAccount": "还没有账户？",
  "email": "邮箱",
  "emailAddress": "邮箱地址",
  "emailAlreadyExists": "该邮箱已被注册",
  "emailNotVerified": "邮箱尚未验证",
  "enter2FACode": "请输入6位验证码",
  "forgotPassword": "忘记密码",
  "invalid2FACode": "验证码无效",
  "invalidCredentials": "邮箱或密码错误",
  "loggingIn": "登录中...",
  "login": "登录",
  "loginNow": "立即登录",
  "loginProtected": "您的账户已受Google身份验证器保护。",
  "loginRequired": "请登录以创建价格提醒。",
  "loginSuccessful": "登录成功",
  "logout": "退出登录",
  "password": "密码",
  "pleaseWait": "请稍候...",
  "rememberMe": "记住我",
  "resetPassword": "重置密码",
  "sendCode": "发送验证码",
  "sending": "发送中...",
  "sessionExpired": "会话已过期，请重新登录。",
  "signup": "注册",
  "signupNow": "立即注册",
  "signupSuccessful": "账户创建成功",
  "twoFactorAuthentication": "双重身份验证",
  "verify": "验证",
  "verify2FA": "验证双重身份验证",
  "verifyEmail": "验证邮箱",
  "verifyResetCode": "验证重置验证码"
}